import React from 'react';
import { LINKS } from '../lib/links';
import { WhatsAppIcon } from './WhatsAppButton';
export function Footer() {
  return <footer className="py-16 md:py-20 px-6 md:px-12 bg-cream border-t border-pine/10" data-id="element-75">
      <div className="max-w-6xl mx-auto" data-id="element-76">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 mb-12" data-id="element-77">
          {/* Logo + tagline */}
          <div className="md:col-span-1 flex flex-col items-center md:items-start text-center md:text-left" data-id="element-78">
            <img src="https://cdn.magicpatterns.com/uploads/sjmJvLdzkMn5K76vaQCoss/549193096_122201298908570946_2685253799441819983_n.jpg" alt="Pines Retreat" className="w-40 md:w-44 h-auto object-contain mb-5" data-id="element-79" />
            <p className="text-clay/80 font-light text-sm leading-relaxed max-w-xs" data-id="element-80">
              A nature retreat for sauna, ice baths, music, and overnight stays
              near Pardes Hanna.
            </p>
          </div>

          {/* Find us */}
          <div className="text-center md:text-left" data-id="element-81">
            <p className="text-clay/70 uppercase tracking-[0.2em] text-xs font-medium mb-5" data-id="element-82">
              Find us
            </p>
            <ul className="space-y-3 text-pine" data-id="element-83">
              <li data-id="element-84">
                <a href={LINKS.instagram} target="_blank" rel="noopener noreferrer" className="hover:text-ember transition-colors" data-id="element-85">
                  Instagram
                </a>
              </li>
              <li data-id="element-86">
                <a href={LINKS.facebook} target="_blank" rel="noopener noreferrer" className="hover:text-ember transition-colors" data-id="element-87">
                  Facebook
                </a>
              </li>
              <li data-id="element-88">
                <a href={LINKS.googleMaps} target="_blank" rel="noopener noreferrer" className="hover:text-ember transition-colors" data-id="element-89">
                  Google Maps
                </a>
              </li>
            </ul>
          </div>

          {/* Stay */}
          <div className="text-center md:text-left" data-id="element-90">
            <p className="text-clay/70 uppercase tracking-[0.2em] text-xs font-medium mb-5" data-id="element-91">
              Stay
            </p>
            <ul className="space-y-3 text-pine" data-id="element-92">
              <li data-id="element-93">
                <a href={LINKS.airbnb} target="_blank" rel="noopener noreferrer" className="hover:text-ember transition-colors" data-id="element-94">
                  Airbnb
                </a>
              </li>
              <li data-id="element-95">
                <a href={LINKS.booking} target="_blank" rel="noopener noreferrer" className="hover:text-ember transition-colors" data-id="element-96">
                  Booking.com
                </a>
              </li>
              <li data-id="element-97">
                <a href={LINKS.whatsapp} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-whatsappDeep hover:text-whatsapp transition-colors font-medium" data-id="element-98">
                  <WhatsAppIcon className="w-3.5 h-3.5" data-id="element-99" />
                  WhatsApp Zev
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-pine/10 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-clay/60" data-id="element-100">
          <div data-id="element-101">© {new Date().getFullYear()} Pines Retreat</div>
          <div data-id="element-102">
            Zev Gelber · +972 58-629-0452 · Near Pardes Hanna / Kfar Pines
          </div>
        </div>
      </div>
    </footer>;
}